import { onUnmounted, watch, type Ref } from 'vue'

export function useFocusTrap(isActive: Ref<boolean>, containerRef: Ref<HTMLElement | null>) {
  let previousActiveElement: HTMLElement | null = null

  const handleTab = (event: KeyboardEvent) => {
    if (!isActive.value || !containerRef.value || event.key !== 'Tab') return

    const focusableElements = containerRef.value.querySelectorAll<HTMLElement>(
      'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )

    if (focusableElements.length === 0) return

    const firstElement = focusableElements[0]
    const lastElement = focusableElements[focusableElements.length - 1]

    if (event.shiftKey) {
      if (document.activeElement === firstElement) {
        event.preventDefault()
        lastElement.focus()
      }
    } else {
      if (document.activeElement === lastElement) {
        event.preventDefault()
        firstElement.focus()
      }
    }
  }

  watch(isActive, (active) => {
    if (active) {
      previousActiveElement = document.activeElement as HTMLElement
      document.addEventListener('keydown', handleTab)
      
      setTimeout(() => {
        if (containerRef.value) {
          const firstFocusable = containerRef.value.querySelector<HTMLElement>(
            'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )
          firstFocusable?.focus()
        }
      }, 100)
    } else {
      document.removeEventListener('keydown', handleTab)
      if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
        previousActiveElement.focus()
      }
    }
  })

  onUnmounted(() => {
    document.removeEventListener('keydown', handleTab)
  })
}
